<template>
  <div id="cat" v-cloak>
    <div class="vx-card mb-3">
      <PrintTemplateReport
        v-if="filter && printData"
        :reportData="printData"
      ></PrintTemplateReport>
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body pb-3">
          <div class="vx-row">
            <div class="w-full vx-col">
              <vs-button
                type="button"
                class="float-right bg-grey purple hide-in-print"
                @click="printWindow()"
                >{{ $t("Print") }}</vs-button
              >
            </div>
          </div>
          <div class="vx-row hide-in-print">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row">
                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mt-1">
                    <label class="vs-select--label">{{
                      $t("Pettycash")
                    }}</label>
                    <v-select
                      label="name"
                      :options="listOfAccountPayer"
                      name="account"
                      v-model="model.pettyCashId"
                      @input="onlistOfAccountPayerSelected"
                      :clearable="false"
                      dir="rtl"
                    >
                    </v-select>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('account')"
                      >{{ errors.first("account") }}</span
                    >
                  </div>

                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mt-1">
                    <label class="vs-select--label">{{ $t("Account") }}</label>
                    <v-select
                      label="name"
                      :options="listOfFloatingAccountPayer"
                      name="floatingAccount"
                      v-model="model.pettyCashReferenceAccount"
                      :clearable="true"
                      :loading="searchFlag"
                      dir="rtl"
                    >
                    </v-select>
                  </div>
                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("FromDate")
                    }}</label>
                    <date-picker
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      v-model="model.fromDate"
                      :label="$t('FromDate')"
                      :clearable="true"
                    />
                  </div>

                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("ToDate")
                    }}</label>
                    <date-picker
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      v-model="model.toDate"
                      :label="$t('ToDate')"
                      :clearable="true"
                    />
                  </div>
                </div>
                <div class="mt-4 flex gap-4 justify-end">
                  <vs-button
                    type="filled"
                    color="#3ec9d6"
                    @click.prevent="resetForm()"
                    >{{ $t("ResetFilter") }}</vs-button
                  >
                  <vs-button type="filled" @click.prevent="submitFilter()" :disabled="!model.pettyCashId ||!model.pettyCashReferenceAccount">{{
                    $t("SubmitFilter")
                  }}</vs-button>
                </div>
              </form>
            </div>
          </div>
          <div class="vx-row pt-4 mt-5">
            <div v-if="filter" class="vx-col w-full mb-base hide-in-print">
              <div
                class="vx-col w-full mb-base"
                v-if="printData && printData.data.length > 0"
              >
                <vs-table :data="printData.data" class="custom-tbl">
                  <template slot="thead">
                    <th style="width: 5%">#</th>
                    <th style="width: 10%">{{ $t("VoucherCode") }}</th>
                    <th style="width: 10%">{{ $t("Date") }}</th>
                    <th style="width: 13%">{{ $t("Description") }}</th>
                    <th style="width: 10%">{{ $t("Debtor") }}</th>
                    <th style="width: 10%">{{ $t("Creditor") }}</th>
                    <th style="width: 10%">{{ $t("Balance") }}</th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr v-for="(row, index) in data" :key="index">
                      <td style="width: 5%">
                        {{ index + 1 }}
                      </td>
                      <td style="width: 10%">
                        {{ row.voucherId }}
                      </td>
                      <td style="width: 15%; direction: ltr">
                        {{ row.createOn.split(" ")[0] }}<br />{{
                          row.createOn.split(" ")[1]
                        }}
                      </td>
                      <td style="width: 20%">
                        {{ row.description ? row.description : "-" }}
                      </td>
                      <td style="width: 15%">
                        {{ formatPrice(row.debtor) }}
                      </td>
                      <td style="width: 15%">
                        {{ formatPrice(row.creditor) }}
                      </td>
                      <td style="width: 15%">
                        {{ formatPrice(row.remaining) }}
                      </td>
                    </vs-tr>
                  </template>
                </vs-table>
                <vs-table :data="printData">
                  <vs-tr>
                    <td style="width: 50%">
                      {{ $t("Sum") }}
                    </td>
                    <td style="width: 15%">
                      {{ formatPrice(printData ? printData.sumOfDebtor : "-") }}
                    </td>
                    <td style="width: 15%">
                      {{
                        formatPrice(printData ? printData.sumOfCreditor : "-")
                      }}
                    </td>
                    <td style="width: 15%">
                      {{
                        formatPrice(printData ? printData.sumOfRemaining : "-")
                      }}
                    </td>
                  </vs-tr>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";
import "@/assets/scss/vuesax-rtl/_report.scss";
import PrintTemplateReport from "./PrintTemplateReport.vue";
import utils from "@/assets/utils/index";

import moment from "moment";
export default {
  components: {
    DataGrid,
    "v-select": vSelect,
    PrintTemplateReport,
  },
  data() {
    return {
      filter: false,
      searchFlag: false,
      printData: [],
      payload: null,
      listOfAccountPayer: [],
      listOfFloatingAccountPayer: [],
      showFilters: false,
      gridSearchData: {
        keyword: "",
      },
      model: {
        fromDate: null,
        toDate: null,
      },
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions({
      fetchPettyCashAccountInfo: "pettyCash/fetchPettyCashAccountInfoById",
      fetchPettyCash: "pettyCash/fetchPettyCash",
      fetchReportPettyCash: "pettyCash/fetchReportPettyCash",
    }),
    getData() {
      this.fetchPettyCash().then((result) => {
        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.name + " " + element.family,
            accountInfo: element.accountInfo,
          };
          this.listOfAccountPayer.push(x);
        });
      });
    },
    resetForm() {
      this.model = {
        pettyCashAccountReferenceType: null,
        pettyCashReferenceAccountCode: null,
        formDate: null,
        toDate: null,
      };
      setTimeout(() => {}, 0);
    },
    onlistOfAccountPayerSelected() {
      this.searchFlag = true;
      if (this.model.pettyCashReferenceAccount) {
        this.model.pettyCashReferenceAccount = null;
      }
      this.fetchPettyCashAccountInfo(this.model.pettyCashId.id).then(
        (result) => {
          this.listOfFloatingAccountPayer = result;
          this.searchFlag = false;
        }
      );
    },

    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    printWindow() {
      window.print();
    },
    submitFilter() {
      if (
        this.model.fromDate == this.model.toDate ||
        this.model.fromDate < this.model.toDate ||
        (this.model.fromDate != "" && this.model.toDate == "") ||
        !this.model.fromDate ||
        !this.model.toDate
      ) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            var params = {};
            if (this.model.toDate && this.model.fromDate) {
              params = {
                maxCreateTime: this.model.toDate,
                minCreateTime: this.model.fromDate,
                pettyCashAccountReferenceType:
                  this.model.pettyCashReferenceAccount.type,
                pettyCashReferenceAccountCode:
                  this.model.pettyCashReferenceAccount.code,
              };
            } else if (this.model.toDate && !this.model.fromDate) {
              params = {
                maxCreateTime: this.model.toDate,
                pettyCashAccountReferenceType:
                  this.model.pettyCashReferenceAccount.type,
                pettyCashReferenceAccountCode:
                  this.model.pettyCashReferenceAccount.code,
              };
            } else if (this.model.fromDate && !this.model.toDate) {
              params = {
                minCreateTime: this.model.fromDate,
                pettyCashAccountReferenceType:
                  this.model.pettyCashReferenceAccount.type,
                pettyCashReferenceAccountCode:
                  this.model.pettyCashReferenceAccount.code,
              };
            } else {
              params = {
                pettyCashAccountReferenceType:
                  this.model.pettyCashReferenceAccount.type,
                pettyCashReferenceAccountCode:
                  this.model.pettyCashReferenceAccount.code,
              };
            }
            this.payload = new URLSearchParams(params).toString();

            this.fetchReportPettyCash(this.payload).then((result) => {
              this.printData = result;
              this.filter = true;
            });
            this.disabled = false;
          }
        });
      } else {
      }
    },
  },
};
</script>
<style>
.purple {
  background: #836dd8 !important;
}
</style>
